import { useEffect } from 'react';
import '@n8n/chat/style.css';
import "../styles/Bot.scss";
import { createChat } from '@n8n/chat';

export const Bot = () => {
	useEffect(() => {
		createChat({
            webhookUrl: 'https://n8n-ovit-production.up.railway.app/webhook/7c6ccce1-8ed9-473b-9786-bbab60bd5631/chat',
            webhookConfig: {
                method: 'POST',
                headers: {}
            },
            target: '#n8n-chat',
            mode: 'window',
            chatInputKey: 'chatInput',
            chatSessionKey: 'sessionId',
            metadata: {},
            showWelcomeScreen: false,
            defaultLanguage: 'en',
            initialMessages: [
                'Hola 👋 Soy tu asistente virtual. Escríbenos para cotizaciones o dudas. Estoy a la orden.😃',
            ],
            i18n: {
                en: {
                    title: '¡Bienvenido a AutoGas Lp!',
                    subtitle: "Estamos listos para asesorarte con la conversión de tu vehiculo 24/7.",
                    footer: '',
                    getStarted: 'New Conversation',
                    inputPlaceholder: 'Escribe tu pregunta..',
                },
            },
        });
	}, []);

	return (<div></div>);
};

export default Bot;